export default "__VITE_ASSET__304076da__"